import React, { useCallback, useState } from 'react';
import Modal from '../../../../elements/Modal/Modal';
import Input from '../../../../elements/forms/Input';
import { useI18n } from '../../../../../data/hooks/i18nHooks';
import ButtonLink from '../../../../elements/ButtonLink';
import { validateFormData } from './validateFormData';
import { useDispatch } from 'react-redux';

function AskForName(props) {
    const { loginData, onClose } = props,
        [authorization, user] = loginData,
        [form, setFormData] = useState({
            firstName: '',
            lastName: '',
        }),
        i18n = useI18n(),
        errors = validateFormData(form),
        dispatch = useDispatch();

    const handleChange = useCallback((field, value) => {
        setFormData((form) => ({ ...form, [field]: value }));
    }, []);

    const handleSubmit = useCallback(
        async (e) => {
            e.preventDefault();
            dispatch(app.actions.ui.busy());

            try {
                const { is_new } = await app.api.session.appleLogin(authorization, {
                    ...user,
                    name: {
                        firstName: form.firstName,
                        lastName: form.lastName,
                    },
                });

                if (is_new) {
                    app.history.push('/new_account');
                }
            } catch (error) {
                console.error(error);
            } finally {
                dispatch(app.actions.ui.free());
            }
        },
        [form]
    );

    return (
        <Modal fullScreen={false} onClose={onClose}>
            <form onSubmit={handleSubmit} action="#">
                <p>{i18n['label.fill.details.below']}</p>
                <Input name="firstName" label={i18n['label.first.name']} value={form.firstName} onChange={(value) => handleChange('firstName', value)} autoFocus />
                <Input name="lastName" label={i18n['label.lastname']} value={form.lastName} onChange={(value) => handleChange('lastName', value)} />
                <br />
                <ButtonLink className="primaryaction" disabled={errors.length} type="submit">
                    {i18n['label.continue']}
                </ButtonLink>
            </form>
        </Modal>
    );
}

export default AskForName;
